import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { Lavorazione } from "../../lavorazioniSlice";

// Create styles
const styles = StyleSheet.create({
	textIntestazione: {
		fontSize: 9,
		borderBottom: "0.5px",
		fontStyle: "normal",
		width: "20%",
		paddingLeft: 1,
		paddingRight: 1,
		paddingTop: 5,
		paddingBottom: 5,
		marginBottom: 1,
	},
	textDati: {
		fontSize: 8,
		fontStyle: "normal",
		// fontWeight: 100,
		whiteSpace: "wrap",
		width: "20%",
		paddingLeft: 1,
		paddingRight: 1,
		paddingTop: 5,
		paddingBottom: 5,
		marginBottom: 1,
	},
	sectionTableIntestazione: {
		fontSize: 9,
		fontStyle: "normal",
		flexDirection: "column",
		// marginHorizontal: 2,
		marginTop: 2,
		// marginLeft: 1,
		backgroundColor: "#3b7d9c",
		color: "#FFF",
		// marginBottom: 10,
		// borderTop: "1px",
		// borderBottom: "0.5px",
	},
	sectionTableDati: {
		flexDirection: "row",
		borderStyle: "solid",
		borderWidth: "0.1px",
		// marginHorizontal: 20,
	},
});

interface ProgammaIncassettamentoLavorazioniPDFProps {
	lavorazioni: Lavorazione[];
}

const ProgammaIncassettamentoLavorazioniPDF = ({
	lavorazioni,
}: // giornoSettimana,
ProgammaIncassettamentoLavorazioniPDFProps) => (
	<View
		style={{
			flexDirection: "column",
			margin: "25px",
			marginTop: "10px",
		}}
		// key={"disinfezione_schedaCarico_" + schedaCarico.id}
	>
		{lavorazioni.length > 0 ? (
			<View
				style={[
					styles.sectionTableIntestazione,
					{
						flexDirection: "row",
					},
				]}
			>
				<Text style={[styles.textIntestazione, { width: "14%" }]}>
					Articolo
				</Text>
				<Text style={[styles.textIntestazione, { width: "6%" }]}>
					Cod. Art. Cli.
				</Text>
				<Text style={[styles.textIntestazione, { width: "14%" }]}>
					Descrizione
				</Text>
				<Text
					style={[
						styles.textIntestazione,
						{ textAlign: "center", width: "6%" },
					]}
				>
					Capi x cassa
				</Text>
				<Text style={[styles.textIntestazione, { width: "14%" }]}>
					Destinazione
				</Text>
				<Text
					style={[
						styles.textIntestazione,
						{ textAlign: "center", width: "6%" },
					]}
				>
					N° casse rich..
				</Text>
				<Text
					style={[
						styles.textIntestazione,
						{ textAlign: "center", width: "6%" },
					]}
				>
					N° capi
				</Text>
				<Text style={[styles.textIntestazione, { width: "8%" }]}>Cassetta</Text>
				<Text
					style={[
						styles.textIntestazione,
						{ textAlign: "center", width: "8%" },
					]}
				>
					Etichetta Cassetta
				</Text>
				<Text
					style={[
						styles.textIntestazione,
						{ textAlign: "center", width: "8%" },
					]}
				>
					Etichetta Pallet
				</Text>
				<Text style={[styles.textIntestazione, { width: "6%" }]}>
					Pettorina
				</Text>
				<Text style={[styles.textIntestazione, { width: "6%" }]}>
					Materiale Sopra
				</Text>
				<Text style={[styles.textIntestazione, { width: "6%" }]}>
					Materiale Sotto
				</Text>
			</View>
		) : (
			<View
				style={[
					styles.sectionTableIntestazione,
					{
						flexDirection: "row",
					},
				]}
			>
				<Text
					style={[styles.textIntestazione, { fontSize: 20, width: "100%" }]}
				>
					Nessuna lavorazione specifica richiesta
				</Text>
			</View>
		)}
		{lavorazioni
			.filter(
				(l) => l.numero_cassette_richieste && l.numero_cassette_richieste > 0
			)
			.map((lavorazione) => (
				<View
					style={styles.sectionTableDati}
					key={"lavorazione_resa_" + lavorazione.id}
				>
					<Text style={[styles.textDati, { width: "14%" }]}>
						{lavorazione.articolo?.descrizione}
					</Text>
					<Text style={[styles.textDati, { width: "6%" }]}>
						{lavorazione.codice_articolo_committente
							? lavorazione.codice_articolo_committente
							: lavorazione.articolo?.codice_articolo}
					</Text>
					<Text style={[styles.textDati, { width: "14%" }]}>
						{lavorazione.descrizione}
					</Text>
					<Text style={[styles.textDati, { textAlign: "center", width: "6%" }]}>
						{lavorazione.articolo?.numero_capi_cassa}
					</Text>
					<Text style={[styles.textDati, { width: "14%" }]}>
						{(lavorazione.destinazione || "") +
							" " +
							(lavorazione.note == null ? "" : lavorazione.note)}
					</Text>
					<Text style={[styles.textDati, { textAlign: "center", width: "6%" }]}>
						{lavorazione.numero_cassette_richieste
							? // lavorazione.numero_cassette_richieste > 0
							  Intl.NumberFormat("it-IT").format(
									lavorazione.numero_cassette_richieste || 0
							  )
							: "-"}
					</Text>
					<Text style={[styles.textDati, { textAlign: "center", width: "6%" }]}>
						{lavorazione.articolo?.numero_capi_cassa &&
							lavorazione.numero_cassette_richieste &&
							Intl.NumberFormat("it-IT").format(
								lavorazione.numero_cassette_richieste *
									(lavorazione.articolo?.numero_capi_cassa || 0)
							)}
					</Text>
					<Text style={[styles.textDati, { width: "8%" }]}>
						{lavorazione.dimensione_cassetta} {lavorazione.materiale_cassetta}
					</Text>
					<Text style={[styles.textDati, { textAlign: "center", width: "8%" }]}>
						{lavorazione.etichetta_su_cassetta ? "SI" : "NO"}
					</Text>
					<Text style={[styles.textDati, { textAlign: "center", width: "8%" }]}>
						{lavorazione.etichetta_pallet ? "SI" : "NO"}
					</Text>
					<Text style={[styles.textDati, { width: "6%" }]}>
						{lavorazione.pettorina_desc}
					</Text>
					<Text style={[styles.textDati, { width: "6%" }]}>
						{lavorazione.materiale_sopra}
					</Text>
					<Text style={[styles.textDati, { width: "6%" }]}>
						{lavorazione.materiale_sotto}
					</Text>
				</View>
			))}
	</View>
);

export default ProgammaIncassettamentoLavorazioniPDF;
